import { useAtomValue } from 'jotai';

import { CONNECTION_STATUS, chronicleDeviceStateAtom } from '@/atoms/chronicle';

/**
 * Hook to access Chronicle device status from the global state.
 * State is automatically updated by ChronicleStateProvider on chronicle:state_changed events.
 *
 * @returns The current device state with derived values
 */
export function useChronicleDeviceStatus() {
  const deviceState = useAtomValue(chronicleDeviceStateAtom);

  const isConnected = deviceState.connectionStatus === CONNECTION_STATUS.CONNECTED;
  const isScanning = deviceState.connectionStatus === CONNECTION_STATUS.SCANNING;
  const isConnecting = deviceState.connectionStatus === CONNECTION_STATUS.CONNECTING;
  const hasError = deviceState.connectionStatus === CONNECTION_STATUS.ERROR;

  return {
    ...deviceState,
    isConnected,
    isScanning,
    isConnecting,
    hasError,
  };
}
